/* Gusto39 Inhaltsseiten: Meldungen der Kontaktformulare, FAQ-Suche, Inhaltsverzeichnis und Drucken der Rechtstexte. */
(() => {
  // Shopify meldet das Ergebnis für alle Kontaktformulare gleich: nur im abgesendeten Formular (Anker = Formular-ID) zeigen.
  const statuses = document.querySelectorAll('[data-contact-status]');
  if (statuses.length) {
    const sent = decodeURIComponent(location.hash.slice(1));
    statuses.forEach((el) => {
      if (sent && el.dataset.contactStatus !== sent) el.remove();
    });
    const shown = document.querySelector('[data-contact-status]');
    if (sent && shown) shown.focus({ preventScroll: false });
  }

  // FAQ: Fragen beim Tippen filtern, leere Gruppen ausblenden.
  document.querySelectorAll('[data-faq]').forEach((root) => {
    const input = root.querySelector('[data-faq-search]');
    const empty = root.querySelector('[data-faq-empty]');
    if (!input) return;
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      let hits = 0;
      root.querySelectorAll('[data-faq-group]').forEach((group) => {
        let groupHits = 0;
        group.querySelectorAll('[data-faq-item]').forEach((item) => {
          const hit = !q || item.textContent.toLowerCase().includes(q);
          item.hidden = !hit;
          if (hit) groupHits += 1;
          if (q && hit) item.open = true;
        });
        group.hidden = groupHits === 0;
        hits += groupHits;
      });
      empty.hidden = hits > 0;
    });
  });

  // Rechtstexte: Inhaltsverzeichnis aus den Überschriften, Cookie-Einstellungen (Shopify-Banner).
  document.querySelectorAll('[data-legal]').forEach((root) => {
    const body = root.querySelector('[data-legal-body]');
    const toc = root.querySelector('[data-toc]');
    // Abschnitte: echte Überschriften; fehlen sie (AGB, Widerruf), ganze fett gesetzte Zeilen. Der Text bleibt unverändert.
    const blank = (n) => n && n.nodeType === 3 && !n.textContent.trim();
    const sib = (n, dir) => { let s = n[dir]; while (blank(s)) s = s[dir]; return s; };
    const lineStart = (el) => { const s = sib(el, 'previousSibling'); return !s || s.nodeName === 'BR'; };
    const lineEnd = (el) => { const s = sib(el, 'nextSibling'); return !s || s.nodeName === 'BR'; };
    let heads = body ? [...body.querySelectorAll('h1, h2')].filter((h) => !h.closest('.shopify-policy__title')) : [];
    if (heads.length < 2 && body) {
      heads = [...body.querySelectorAll('strong, b')].filter((el) => el.textContent.trim().length > 2 && el.textContent.trim().length < 90 && lineStart(el) && lineEnd(el));
      heads.forEach((el) => el.classList.add('pg-legal__h'));
    }
    body?.querySelectorAll('table').forEach((t) => {
      if (t.parentElement.classList.contains('pg-legal__table')) return;
      const wrap = document.createElement('div');
      wrap.className = 'pg-legal__table';
      t.before(wrap);
      wrap.append(t);
    });
    if (toc && heads.length > 1) {
      const list = toc.querySelector('ol');
      const links = new Map();
      heads.forEach((h, i) => {
        if (!h.id) h.id = `abschnitt-${i + 1}`;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent.trim();
        a.addEventListener('click', () => { if (!desktop.matches) toc.open = false; });
        li.append(a);
        list.append(li);
        links.set(h, a);
      });
      const count = toc.querySelector('[data-toc-count]');
      if (count) count.textContent = `${heads.length} ${count.dataset.tocCount}`;
      // Desktop: Verzeichnis immer offen und mitlaufend, mobil eingeklappt
      const desktop = window.matchMedia('(min-width: 1024px)');
      const sync = () => { toc.open = desktop.matches; };
      sync();
      desktop.addEventListener('change', sync);
      toc.hidden = false;
      if ('IntersectionObserver' in window) {
        let current;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            current?.removeAttribute('aria-current');
            current = links.get(e.target);
            current.setAttribute('aria-current', 'true');
            if (desktop.matches) {
              const box = list.getBoundingClientRect();
              const r = current.getBoundingClientRect();
              if (r.top < box.top || r.bottom > box.bottom) list.scrollTop += r.top - box.top - box.height / 2;
            }
          });
        }, { rootMargin: '-100px 0px -70% 0px' });
        heads.forEach((h) => io.observe(h));
      }
    }
    const consent = root.querySelector('[data-consent]');
    if (consent && window.privacyBanner?.showPreferences) {
      consent.hidden = false;
      consent.addEventListener('click', () => window.privacyBanner.showPreferences());
    }
  });

  // Schritte und Kacheln beim Scrollen nacheinander einblenden; ohne IntersectionObserver oder bei reduzierter Bewegung sofort sichtbar.
  const reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    reveals.forEach((root) => {
      root.classList.add('pg-reveal');
      Array.from(root.children).forEach((el) => io.observe(el));
    });
  }

  // Parallaxe: Elemente mit data-parallax (Faktor) bewegen sich beim Scrollen etwas langsamer als die Seite.
  const layers = document.querySelectorAll('[data-parallax]');
  if (layers.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;
    const update = () => {
      ticking = false;
      layers.forEach((el) => {
        const box = el.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        const shift = (box.top + box.height / 2 - window.innerHeight / 2) * parseFloat(el.dataset.parallax || '0.1');
        el.style.transform = `translate3d(0, ${shift.toFixed(1)}px, 0)`;
      });
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
})();
